import { SelectGroup } from "@/components/ui/select";

export function RrtPartPlatformSelect({
  currentExport,
  data,
  setData,
  dataOptions,
}) {
  if (currentExport == "rrt reporting") {
    return (
      <SelectGroup
        label="Part Platform"
        menuPosition="fixed"
        isClearable
        placeholder="Select Part Platform"
        className="w-full"
        options={dataOptions.part_platforms ? dataOptions.part_platforms : []}
        value={
          dataOptions.part_platforms &&
          dataOptions.part_platforms.find(
            (option) => option.value === data.part_platform_id,
          )
        }
        onChange={(e) => {
          setData({
            ...data,
            export_type: null,
            part_platform_id: e ? e.value : null,
          });
        }}
      />
    );
  }
  return null;
}
